import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'studio-components/icon/icon.module';
import { PopupMenuItemComponent } from './components/popup-menu-item/popup-menu-item.component';
import { PopupMenuComponent } from './components/popup-menu/popup-menu.component';
import { PopupMenuGroupComponent } from './components/popup-menu-group/popup-menu-group.component';
import { PopupMenuOptionalAnchorComponent } from './components/popup-menu-optional-anchor/popup-menu-optional-anchor.component';

const exportedModules = [PopupMenuComponent, PopupMenuGroupComponent, PopupMenuItemComponent];

@NgModule({
  declarations: [...exportedModules, PopupMenuOptionalAnchorComponent],
  imports: [CommonModule, IconModule],
  exports: exportedModules,
})
export class PopupMenuModule {}
